'use strict';

require('../modules/forms/forms');

angular.module('far.forms.newsArchiveForm', ['dekky.forms'])
    .service('newsArchiveForm', function(form, NewsArchive, fileUploadFilters, showModalMessage) {
        var newsArchiveForm = form('newsArchive');

        newsArchiveForm

            .addField('date', 'dateDropdowns', {
                validators: {
                    required: true
                },
                label: 'Дата'
            })
            .addField('title', 'text', {
                validators: {
                    required: true
                },
                label: 'Заголовок'
            })
            .addField('brief_text', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: true,
                    placeholder: '...'
                },
                label: 'Анонс'
            })
            .addField('text', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: true,
                    placeholder: '...'
                },
                label: 'Текст'
            });

        return newsArchiveForm;
    });
